export default __webpack_public_path__ + "static/media/mic.61393dd7.svg";